export default __webpack_public_path__ + "static/blogic-media-083f27d6460d59ecf02047e7fcffd432.svg";